export const UPLOAD_SLOTS = 1;
